export const BlockingPlaces = {
  POS: 'POS',
  BACK_OFFICE: 'BACK_OFFICE',
  PORTAL: 'PORTAL',
};
export const UnblockingPlaces = {
  POS: 'POS',
  BACK_OFFICE: 'BACK_OFFICE',
};
